module.exports = __webpack_public_path__ + "img/memu-off_01.48b2b77f.png";